import { createSlice } from '@reduxjs/toolkit';
import { ICustomer } from '../../../../dto';
import { setCustomer } from '../actions';
import { MN_CUSTOMERS, TYPE_ELEMENT } from '../../../../common';

export interface CustomerState {
  data: ICustomer | null;
  loading: boolean;
  error: string | null;
}

const initialState: CustomerState = {
  data: null,
  loading: false,
  error: null,
};

export const customerSlice = createSlice({
  name: `${MN_CUSTOMERS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCustomer, (state, { payload }) => {
      state.data = payload;
    });
  },
});
